import { type RefCallback, useCallback } from 'react';

/**
 * Adapts a react-dnd connector for use as a `ref`. The connectors return a
 * ReactElement, which React 19 rejects because a ref callback may only return a
 * cleanup function.
 *
 * The result is memoized on the connector, which react-dnd keeps stable. An
 * unstable ref callback would make React detach and reattach on every render,
 * and each detach/reattach resubscribes the connector in the backend.
 */
export function useDndRef<T extends HTMLElement>(
  connector: (node: T | null) => unknown,
): RefCallback<T> {
  return useCallback(
    (node) => {
      connector(node);
    },
    [connector],
  );
}
